@if (operation) {
  <oui-accordion
    #accordion
    class="with-border rounded padding-32"
    [class.operation-card--error]="hasErrorBorder"
    [(expanded)]="expanded"
    (expandedChange)="onAccordionExpandedChange($event)">
    <oui-accordion-header class="height-auto">
      <oui-accordion-title>
        <app-operation-accordion-title [operation]="operation" [index]="index" [showDetails]="!accordion.expanded">
        </app-operation-accordion-title>
      </oui-accordion-title>
      <oui-accordion-actions>
        @if (!deleteDisabled) {
          <oui-button type="text" (click)="onDeleteClick()"> Supprimer </oui-button>
        }
      </oui-accordion-actions>
    </oui-accordion-header>
    <div class="flex-vertical gap-32 padding-top-32">
      @if (operation.operationType == acteGestionType) {
        <app-search-nature-autocomplete
          #natureAutocompleteCmp
          [isRequired]="true"
          (onNatureSelected)="onNatureOperationSelected($event)"
          [currentNatureId]="$safeNavigationMigration(initOperationConfig?.natureOperation?.id)"
          [enveloppeId]="$safeNavigationMigration(operation.produit?.enveloppeNavigation?.code)">
        </app-search-nature-autocomplete>
      }
      @if (operation.operationType == souscriptionType && produitAutocompleteOptions) {
        <oui-autocomplete
          #produitAutocomplete
          label="Produit"
          [control]="produitControl"
          [displayResetButton]="true"
        [options]="produitAutocompleteOptions"></oui-autocomplete>
      }
      @if (!isHabilitedProduit()) {
        <oui-banner
          title="Vous n'avez aucune habilitation active pour ce produit"
          declination="error"
          [action]="noHabilAction"
        [showCloseButton]="false"></oui-banner>
      }
      @if (operation.operationConfigId) {
        <app-subscribe-specific
          [operation]="operation"
          [operationConfigId]="operation.operationConfigId"
          (onSpecificDataChanged)="onSpecificDataChange($event)"
          [initialData]="initSpecificData"
          [operationIndex]="index"
        [touchNonce]="touchNonce"></app-subscribe-specific>
      } @else {
        @if (isChoiceDone) {
          <app-no-config-banner></app-no-config-banner>
        }
      }
    </div>
  </oui-accordion>
}
